import React from 'react';
import '../scss/SelectedMdrms.scss';

const SelectedMdrms = ({ mdrms = [], onRemove, onRemoveAll }) => {
    if (!mdrms.length) return null;

    return (
        <div className="container">
            <div className="content">
                <h4 className="heading">
                    Selected MDRMs:
                </h4>
                <button
                    type="button"
                    onClick={() => onRemoveAll && onRemoveAll()}
                    className="remove-all"
                >
                    Remove all
                </button>
            </div>
            <div className="mdrm-list">
                {mdrms.map((mdrm, idx) => (
                    <div
                        key={`${mdrm}-${idx}`}
                        className="mdrm-pill"
                    >
                        {mdrm}
                        {' '}
                        <span
                            onClick={() => onRemove && onRemove(mdrm)}
                            className="selected-mdrms"
                            title={`Remove ${mdrm}`}
                        >
                            X
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SelectedMdrms;
